import React from 'react';
import { Activity, Target, Cpu } from 'lucide-react';

export const Header = () => {
  return (
    <header className="h-14 border-b border-slate-800/60 glass flex items-center justify-between px-6">
      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="w-8 h-8 rounded bg-cyan-500/20 flex items-center justify-center border border-cyan-500/50">
            <Activity className="w-4 h-4 text-cyan-400" />
          </div>
          <div className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
        </div>
        <div>
          <h1 className="font-heading text-lg font-bold tracking-wide">
            <span className="text-white">RESCUE </span><span className="text-red-500">AID</span>
          </h1>
          <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
            Vision Intelligence Console
          </p>
        </div>
      </div>
      
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 text-xs font-mono text-slate-400">
          <Cpu className="w-3 h-3 text-cyan-400" />
          <span>AI: ONLINE</span>
          <span className="relative flex h-6 w-6 items-center justify-center" title="System AI online">
            <span className="absolute inline-flex h-6 w-6 rounded-full bg-emerald-500/80 animate-pulse" />
            <span className="relative inline-flex h-4 w-4 rounded-full bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.8)] ring-2 ring-emerald-500/60" />
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs font-mono text-slate-400">
          <Target className="w-3 h-3 text-cyan-400" />
          <span>MONITORING ACTIVE</span>
        </div>
      </div>
    </header>
  );
};
